import { render, staticRenderFns } from "./UserDevices.vue?vue&type=template&id=085053d0"
import script from "./UserDevices.vue?vue&type=script&lang=js"
export * from "./UserDevices.vue?vue&type=script&lang=js"
import style0 from "./UserDevices.vue?vue&type=style&index=0&id=085053d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports